// Types for the "Ask Jeff" feature (025): flagging tournament hands for Jeff's commentary and
// the Super Editor's review surface.

import type { AuctionBid, Hand } from './problems';
import type { CountingProblem } from './counting';

/**
 * The section a hand was flagged under. Module questions use their canonical
 * `{family}.{topic}.{module}` key; the two other hand surfaces have fixed names.
 */
export const ASK_JEFF_SECTION_OVERCALLING = 'overcalling';
export const ASK_JEFF_SECTION_COUNTING = 'counting';

/** Flag state for one hand — drives the button on the practice pages. */
export interface AskJeffFlag {
  tableResultId: number;
  sectionKey: string;
  note: string | null;
}

/** A section that currently has flagged hands — the review page's filter options. */
export interface AskJeffSection {
  sectionKey: string;
  sectionLabel: string;
  count: number;
}

/**
 * The bidding half of a review item. The auction is COMPLETE and `answer` is stated — the
 * review surface shows the question as the learner met it, but with the answer given.
 */
export interface AskJeffHand {
  playerHand: Hand;
  auction: AuctionBid[];
  vulnerability: string;
  dealer: string;
  decisionSeat: 'N' | 'E' | 'S' | 'W';
  scoringType: string;
  tournamentTitle: string | null;
  prompt: string;
  answer: string;
  /** Yes/No modules only: the call Jeff actually made. Null for call questions. */
  actualCall: string | null;
}

export interface AskJeffReviewItem {
  tableResultId: number;
  sectionKey: string;
  sectionLabel: string;
  note: string | null;
  flaggedAt: string;
  /** Jeff's recorded comment, or null when he has not answered this hand yet. */
  jeffComment: string | null;
  renderer: 'auction' | 'counting';
  hand: AskJeffHand | null;
  countingProblem: CountingProblem | null;
  /** True when the question could not be rebuilt; notes and the comment box still apply. */
  handUnavailable: boolean;
}
